"use client";
import Link from "next/link";
import styles from "./navbar.module.css";
import {
    Container,
    Stack,
    Menu,
    IconButton,
    Popper,
    ListItem,
    Collapse,
    Grid2,
    Box,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import { usePathname } from "next/navigation";
import Image from "next/image";

export default function Navbar() {
    let [mobileMenuOpen, setMobileMenuOpen] = useState(false);

    let pathname = usePathname();
    let desktopNavBar = useRef(null);

    useEffect(() => {
        function handleScroll() {
            setMobileMenuOpen(false);
            if (desktopNavBar.current) {
                let container = desktopNavBar.current as HTMLElement;
                if (
                    window.scrollY > 10 ||
                    pathname === "/residential-portfolio"
                ) {
                    container.style.backgroundColor = "black";
                } else {
                    container.style.backgroundColor = "rgba(0, 0, 0, 0.01)";
                }
            }
        }

        handleScroll(); // Call immediately to set initial state
        window.addEventListener("scroll", handleScroll);
    }, [pathname]); // Add pathname as dependency

    let [residentialMenuAnchor, setResidentialMenuAnchor] =
        React.useState<null | HTMLElement>(null);


    useEffect(() => {
        // Close mobile menu on navigation
        setMobileMenuOpen(false);
    }, [pathname]);

    const residentialMenuOpen = Boolean(residentialMenuAnchor);

    function handleResidentialMenu(event: React.MouseEvent<HTMLButtonElement>) {
        setResidentialMenuAnchor(event.currentTarget);
    }

    function preventScroll(event: Event) {
        event.preventDefault();
    }
    function handleMobileMenu(event: React.MouseEvent<HTMLButtonElement>) {
        if (mobileMenuOpen) {
            setMobileMenuOpen(false);
        } else {
            setMobileMenuOpen(true);
        }
        console.log(mobileMenuOpen)
    }

    let navbar = useRef(null);
    let [residentialColl, setresidentialColl] = useState(false);
    return (
        <>
            <Menu
                open={residentialMenuOpen}
                anchorEl={residentialMenuAnchor}
                onClose={() => {
                    setResidentialMenuAnchor(null);
                }}
                style={{ marginTop: "1rem" }}
            >
                <div
                    style={{
                        width: 400,
                        paddingLeft: "0.5rem",
                        paddingRight: "0.5rem",
                    }}
                >
                    <ul className={styles.listelem}>
                        <li>
                            <Link
                                href="/residential-portfolio"
                                className={styles.menu_link}
                            >
                                Residential Properties
                            </Link>
                        </li>
                        <li>
                            <Link
                                href="/residential-portfolio/Duplex"
                                className={styles.menu_link}
                            >
                                Duplex Residences
                            </Link>
                        </li>
                        <li>
                            <Link
                                href="/residential-portfolio/Multi Family"
                                className={styles.menu_link}
                            >
                                Multi-Family Residences
                            </Link>
                        </li>
                        <li style={{ padding: "0px" }}>
                            <FeaturedProject />
                        </li>
                    </ul>
                </div>
            </Menu>
            <Popper open={mobileMenuOpen} anchorEl={navbar.current}>
                <div
                    style={{
                        width: "100vw",
                        backgroundColor: "black",
                        color: "white",
                    }}
                >
                    <ListItem
                        sx={{
                            borderBottom: "1px solid #ccc",
                        }}
                    >
                        <Link href={"/about"} className={styles.link}>
                            About
                        </Link>
                    </ListItem>
                    <ListItem>
                        <Link
                            href={""}
                            className={`${styles.link}`}
                            onClick={() => {
                                setresidentialColl(!residentialColl);
                            }}
                        >
                            Residential
                        </Link>
                    </ListItem>

                    <Collapse in={residentialColl}>
                        <ListItem>
                            <Link
                                href={"/residential-portfolio"}
                                className={`${styles.link}`}
                                style={{ color: "whitesmoke" }}
                            >
                                Residential Portfolio
                            </Link>
                        </ListItem>
                        <ListItem>
                            <Link
                                href={"/residential-portfolio/Duplex"}
                                className={`${styles.link}`}
                                style={{ color: "whitesmoke" }}
                            >
                                Duplex Residences
                            </Link>
                        </ListItem>
                        <ListItem>
                            <Link
                                href={"/residential-portfolio/Multi Family"}
                                className={`${styles.link}`}
                                style={{ color: "whitesmoke" }}
                            >
                                Multi-Family Residences
                            </Link>
                        </ListItem>
                    </Collapse>

                    <hr></hr>
                    <ListItem>
                        <Link href={"/solutions"} className={styles.link}>
                            Our Solutions
                        </Link>
                    </ListItem>
                    <hr></hr>
                    <ListItem>
                        <Link href={"/contact"} className={styles.link}>
                            Contact Us
                        </Link>
                    </ListItem>
                    <hr></hr>
                    <ListItem>
                        <Link href={"/careers"} className={styles.link}>
                            Careers
                        </Link>
                    </ListItem>

                    <hr></hr>
                </div>
            </Popper>
            <div className={styles.nav_mobile} ref={navbar}>
                <Container>
                    <Stack
                        direction={"row"}
                        justifyContent={"space-between"}
                        alignItems={"center"}
                    >
                        <Link href="/">
                            <img
                                src="/logo-medallion-blue.png"
                                width={150}
                            ></img>
                        </Link>
                        <IconButton
                            sx={{ color: "white" }}
                            onClick={handleMobileMenu}
                        >
                            {mobileMenuOpen ? <CloseIcon /> : <MenuIcon />}
                        </IconButton>
                    </Stack>
                </Container>
            </div>
            <nav
                className={`${styles.nav} ${pathname !== "/" ? styles.nav_black : ""
                    }`}
                ref={desktopNavBar}
            >
                <Container>
                    <Stack
                        direction="row"
                        justifyContent="space-between"
                        alignItems={"center"}
                    >
                        <Stack
                            direction={"row"}
                            alignItems={"center"}
                            spacing={3}
                        >
                            <Link href="/">
                                <img
                                    src="/logo-medallion-blue.png"
                                    width={150}
                                ></img>
                            </Link>
                            <Link href="/about" className={styles.link}>
                                About
                            </Link>

                            <button
                                className={styles.link_btn}
                                onClick={handleResidentialMenu}
                            >
                                Residential
                                <span className={styles.link_btn_span}>
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 48 48"
                                        className={styles.link_btn_svg}
                                    >
                                        <g data-icon="icon--arrow-down">
                                            <path
                                                d="M24.312,37.431 L1.24,14.359 L5.031,10.569 L24.312,29.851 L43.594,10.569 L47.385,14.359 L24.312,37.431 z"
                                                id="arrow-down"
                                                fill="white"
                                            ></path>
                                        </g>
                                    </svg>
                                </span>
                            </button>
                            <Link href="/solutions" className={styles.link}>
                                Our Solutions
                            </Link>

                            <Link href="/careers" className={styles.link}>
                                Careers
                            </Link>
                        </Stack>
                        <Link href="/contact" className={styles.link}>
                            Contact Us
                        </Link>
                    </Stack>
                </Container>
            </nav>
        </>
    );
}

function FeaturedProject() {
    return (
        <Link
            href="/residential-portfolio/3118_windsor"
            style={{ textDecoration: "none" }}
        >
            <Grid2 container>
                <Grid2 size={8}>
                    <p
                        style={{
                            color: "grey",
                            fontSize: "0.9rem",
                        }}
                    >
                        Featured Project
                    </p>
                    <p
                        style={{
                            fontSize: "1.2rem",
                            color: "black",
                            marginBottom: "0px",
                        }}
                    >
                        3118 Windsor Street
                    </p>
                    <p
                        className="mono_font"
                        style={{
                            marginTop: "0px",
                            paddingTop: "0px",
                            color: "grey",
                        }}
                    >
                        Vancouver, BC
                    </p>
                </Grid2>
                <Grid2 size={4} p={"1rem"}>
                    <Box
                        sx={{
                            position: "relative",
                            width: "100%",
                            aspectRatio: "1 / 1",
                        }}
                    >
                        <Image
                            src="/images/3118 Windsor/DSC08879.jpg"
                            alt="3118 Windsor"
                            fill
                            style={{
                                objectFit: "cover",
                            }}
                        />
                    </Box>
                </Grid2>
            </Grid2>
        </Link>
    );
}
